import video1 from '../assets/videos/video1.mp4';
import video2 from '../assets/videos/video2.mp4';
import video3 from '../assets/videos/video3.mp4';
import video4 from '../assets/videos/video4.mp4';
import video5 from '../assets/videos/video5.mp4';


export const getVideoByKey = (key: string) => {
    const videoMap: Record<string, string> = {
        video1,
        video2,
        video3,
        video4,
        video5,
    };

    return key ? videoMap[key] : undefined;
};